import { FC, Suspense, useState } from 'react';

import { MIME_TYPES } from '@savgroup-front-common/constants';

import { SessionType } from '../../../../api/Attachment/getFilesUploadLinksBySessionIdCommand';
import { Modal, MODAL_SIZES } from '../../../../atoms/modal';
import { BaseLoader } from '../../../../molecules/BaseLoader';

import { QrCodeImportModalContent } from './QrCodeImportModalContent/QrCodeImportModalContent';

interface QrCodeImportProps {
  isOpen: boolean;
  isSubmitLoading: boolean;
  onUploadFinishClick: ({ sessionId }: { sessionId?: string }) => void;
  additionalInformationId: string;
  claimId: string;
  allowedMimeTypes?: MIME_TYPES[];
  sessionType?: SessionType;
}

export const QrCodeImportModal: FC<QrCodeImportProps> = ({
  isOpen,
  onUploadFinishClick,
  isSubmitLoading,
  additionalInformationId,
  claimId,
  allowedMimeTypes,
  sessionType = SessionType.SINGLE_FILE,
}) => {
  const [sessionId, setSessionId] = useState<string>();

  return (
    <Modal
      isOpen={isOpen}
      size={MODAL_SIZES.SMALL}
      shouldCloseOnDimmerClick
      onClose={() => {
        onUploadFinishClick({
          sessionId,
        });
      }}
    >
      <Suspense fallback={<BaseLoader />}>
        <QrCodeImportModalContent
          onUploadFinishClick={() => {
            onUploadFinishClick({
              sessionId,
            });
          }}
          isSubmitLoading={isSubmitLoading}
          onCreateUploadSession={(fileAttachmentUploadLink) => {
            setSessionId(fileAttachmentUploadLink.sessionId);
          }}
          additionalInformationId={additionalInformationId}
          claimId={claimId}
          allowedMimeTypes={allowedMimeTypes}
          sessionType={sessionType}
        />
      </Suspense>
    </Modal>
  );
};
